import { JobStage } from '@/constants/job/jobStages'
import { BACKEND_PRIVATE, BACKEND_PUBLIC } from '../../base'
import { JobStatus } from '@/constants/job/jobStatuses'

export async function getMyCustomerJobList (
  { stages, limit, offset }:
  { stages?: Array<JobStage>, limit: number, offset: number }
) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ jobs: LX.MyCustomerJobListItem[] }>>('/me/simple-jobs/list-as-customer', {
    params: {
      stages,
      limit,
      offset,
    }
  })
}

export async function getMyCustomerCompletedJobList ({ limit, offset }: { limit: number, offset: number }) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ jobs: LX.MyCustomerJobListItem[] }>>('/me/simple-jobs/list-as-customer-of-completed', {
    params: {
      limit,
      offset,
    }
  })
}

// TODO New Request
export async function getWorkerList (
  { limit, offset, jobStages = [], applicationStatuses = [] }:
    { limit: number, offset: number, jobStages?: JobStage[], applicationStatuses?: JobStatus[] }
) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ applications: LX.JobApplication[] }>>('/me/jobs/simple/applications/list-as-freelancer', {
    params: {
      limit: limit,
      offset,
      jobStages,
      applicationStatuses,
    }
  })
}

export async function getPublicJobsList (params: LX.BrowseJobsFilter) {
  return BACKEND_PUBLIC.get<LX.Paginated<{ jobs: LX.JobListItem[] }>>('/simple-jobs/list', { params })
}
